// extracted by mini-css-extract-plugin
export default {"marginbottom":"DateFormat_marginbottom__e4aVe"};